import { render, staticRenderFns } from "./CompanyDepartment.vue?vue&type=template&id=5fd3029a&scoped=true&"
import script from "./CompanyDepartment.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartment.vue?vue&type=style&index=0&id=5fd3029a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd3029a",
  null
  
)

export default component.exports